import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {LuLayoutDashboard} from "react-icons/lu";
import {BiSolidCarBattery} from "react-icons/bi";
import {GiReturnArrow} from "react-icons/gi";

function Home() {

    return (
        <React.Fragment>
            <Header/>


            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <LuLayoutDashboard className='ms-2' />
                        داشبورد</h1>

                </div>

                <section className="section dashboard">
                    <div className="row rtl">


                        <div className="col-xxl-4 col-md-6">
                            <div className="card info-card sales-card">



                                <div className="card-body rtl">
                                    <h5 className="card-title">تعداد فروش <span>| ۷ روز گذشته</span></h5>

                                    <div className="d-flex align-items-center">
                                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                            <BiSolidCarBattery />
                                        </div>
                                        <div className="pe-3">
                                            <h6>145</h6>
                                            <span className="text-success small pt-1 fw-bold">12%</span> <span className="text-muted small pt-2 ps-1">افزایش فروش</span>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className="col-xxl-4 col-md-6">
                            <div className="card info-card revenue-card">



                                <div className="card-body">
                                    <h5 className="card-title">تعداد فروش <span>|  ۳۰ روز    گذشته</span></h5>

                                    <div className="d-flex align-items-center">
                                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                            <BiSolidCarBattery />
                                        </div>
                                        <div className="pe-3">
                                            <h6>256</h6>
                                            <span className="text-success small pt-1 fw-bold">8%</span> <span className="text-muted small pt-2 ps-1">افزایش</span>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className="col-xxl-4 col-xl-12">

                            <div className="card info-card customers-card">



                                <div className="card-body">
                                    <h5 className="card-title">تعداد مرجوعی <span>| 30 روز    گذشته</span></h5>

                                    <div className="d-flex align-items-center">
                                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                            <GiReturnArrow />
                                        </div>
                                        <div className="pe-3">
                                            <h6>65</h6>
                                            <span className="text-danger small pt-1 fw-bold">10%</span> <span className="text-muted small pt-2 ps-1">افزایش</span>

                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>
                </section>

            </main>
            <Navbar page="dashboard"/>
        </React.Fragment>
    );
}

export default Home;